import { create } from 'zustand';
import { InstructionsAugmentation } from 'types/pop-out-instructions';

const resolveInstructionsAugmentation = ({
  currentLink,
  nextLink,
  nextAugmentation,
  currentAugmentation,
}: {
  currentLink: string | null;
  nextLink: string | null;
  nextAugmentation?: InstructionsAugmentation | null;
  currentAugmentation: InstructionsAugmentation | null;
}) => {
  if (!nextLink) {
    return null;
  }

  if (nextAugmentation !== undefined) {
    return nextAugmentation;
  }

  if (nextLink === currentLink) {
    return currentAugmentation;
  }

  return null;
};

export const usePopOutInstructionsLink = create<{
  popOutInstructionsLink: string | null;
  popOutInstructionsInnerHtmlToScroll: string | null;
  popOutInstructionsAugmentation: InstructionsAugmentation | null;
  setPopOutInstructionsLink: (
    link: string | null,
    innerHtmlToScroll?: string | null,
    augmentation?: InstructionsAugmentation | null,
  ) => void;
}>((set) => ({
  popOutInstructionsLink: null,
  popOutInstructionsInnerHtmlToScroll: null,
  popOutInstructionsAugmentation: null,
  setPopOutInstructionsLink: (
    link: string | null,
    innerHtmlToScroll?: string | null,
    augmentation?: InstructionsAugmentation | null,
  ) =>
    set((state) => ({
      popOutInstructionsLink: link,
      popOutInstructionsInnerHtmlToScroll: link
        ? (innerHtmlToScroll ?? null)
        : null,
      popOutInstructionsAugmentation: resolveInstructionsAugmentation({
        currentLink: state.popOutInstructionsLink,
        nextLink: link,
        nextAugmentation: augmentation,
        currentAugmentation: state.popOutInstructionsAugmentation,
      }),
    })),
}));
